const onHexagonClick = event => {
    var hexagon = event.currentTarget;
    var title = hexagon.getAttribute('data-title');

    // prevent double count on double clicks
    if (hexagon.getAttribute('data-clicked') === null) {
        window._paq.push([ 'trackEvent', 'Hexagon', 'Click auf Hexagon', title ]);
        hexagon.setAttribute('data-clicked', 1);
    } else {
        hexagon.setAttribute('data-clicked', (parseInt(hexagon.getAttribute('data-clicked')) + 1));
        window._paq.push([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Hexagon', hexagon.getAttribute('data-clicked') ]);
    }
};

const onColorcardClick = event => {
    var colorcard = event.currentTarget;
    var title = colorcard.getAttribute('data-title');

    // prevent double count on double clicks
    if (colorcard.getAttribute('data-clicked') === null) {
        window._paq.push([ 'trackEvent', 'Colorcard', 'Click auf Colorcard', title ]);
        colorcard.setAttribute('data-clicked', 1);
    } else {
        colorcard.setAttribute('data-clicked', (parseInt(colorcard.getAttribute('data-clicked')) + 1));
        window._paq.push([ 'trackEvent', 'Mehrfach-Click Colorcard', 'Mehrfach-Click auf Colorcard', colorcard.getAttribute('data-clicked') ]);
    }
};

const onIshTeaserClick = event => {
    var ishTeaser = event.currentTarget;
    var page = window.location.href;
    // prevent double count on double clicks
    if (ishTeaser.getAttribute('data-clicked') === null) {
        window._paq.push([ 'trackEvent', 'ISH Teaser', 'Click auf ISH Teaser', page ]);
        ishTeaser.setAttribute('data-clicked', 1);
    } else {
        ishTeaser.setAttribute('data-clicked', (parseInt(ishTeaser.getAttribute('data-clicked')) + 1));
        window._paq.push([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf ISH-Teaser', ishTeaser.getAttribute('data-clicked') ]);
    }


};

const onSearchButtonClick = event => {
    var searchButton = event.currentTarget;
    var page = window.location.href;
    // prevent double count on double clicks
    if (searchButton.getAttribute('data-clicked') === null) {
        window._paq.push([ 'trackEvent', 'Suchbutton', 'Suche ausgeloest auf Seite', page ]);
        searchButton.setAttribute('data-clicked', 1);
    } else {
        searchButton.setAttribute('data-clicked', (parseInt(searchButton.getAttribute('data-clicked')) + 1));
        window._paq.push([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Such-Button', searchButton.getAttribute('data-clicked') ]);
    }

};

const onServiceMenuClick = event => {
    var serviceLink = event.currentTarget;
    var title = serviceLink.textContent;
    var page = window.location.href;

    if (serviceLink.getAttribute('data-clicked') === null) {
        window._paq.push([ 'trackEvent', 'Service Menu', title, page ]);
        serviceLink.setAttribute('data-clicked', 1);
    } else {
        serviceLink.setAttribute('data-clicked', (parseInt(serviceLink.getAttribute('data-clicked')) + 1));
        window._paq.push([ 'trackEvent', 'Mehrfach-Click', 'Mehrfach-Click auf Service-Link', serviceLink.getAttribute('data-clicked') ]);
    }
};

const init = () => {
    //track clicks on colorcard
    var colorcard = document.querySelectorAll('a.colorcard');
    for (var i = 0; i < colorcard.length; i++) {
        //console.log('add colorcard click event' + i);
        colorcard[i].addEventListener('click', onColorcardClick);
    }

    //track clicks on hexagons
    var hexagons = document.querySelectorAll('li.hexagone-teaser-list__item a');
    for (var h = 0; h < hexagons.length; h++) {
        // console.log('add hexagon click event' + h);
        hexagons[h].addEventListener('click', onHexagonClick);
    }

    // track ISH-Bannerpage
    var ishTeasers = document.querySelectorAll('.ish-wrapper');
    for (var j = 0; j < ishTeasers.length; j++) {
        ishTeasers[j].addEventListener('click', onIshTeaserClick);
    }

    // track search button on homepage and subpages
    var searchButtons = document.querySelectorAll('button.btn-search, .search-modal [type=submit]');
    for (var k = 0; k < searchButtons.length; k++) {
        searchButtons[k].addEventListener('click', onSearchButtonClick);
    }

    // track links from service navigation
    var serviceNavLinks = document.querySelectorAll('.services-panel__item a');
    for (var l = 0; l < serviceNavLinks.length; l++) {
        serviceNavLinks[l].addEventListener('click', onServiceMenuClick);
    }
};

export {
    init,
};


